//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 07.09.2015.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .directive('srsngCollapsibleBox', srsngCollapsibleBox);

    function srsngCollapsibleBox() {
        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/widgets/collapsible-box/collapsible-box.html',
            transclude: true,
            scope: {
                title: '@srsngCollapsibleBoxTitle',
                collapsed: '=srsngCollapsibleBoxCollapsed',
                statusIcon: '=srsngCollapsibleBoxStatusIcon'
            },
            controller: controller,
            link: function (scope, element, attrs) {
                // this is intentional override
            }
        };

        function controller($scope) {
            $scope.toggle = function () {
                $scope.collapsed = !$scope.collapsed;
            };
        }
    }
})();